
import EmployeeDetails from '@/common/components/employee/employee-details.vue';
import { Component, Mixins, Prop } from 'vue-property-decorator';
import { mapState } from 'vuex';
import AuthMixin from '@/common/mixins/auth.mixin';
import ShiftMixin from '../shift.mixin';
import ShiftDeleteModal from './shift-delete-modal.vue';
import { RequestedShift, RequestedWorker } from '../shift.types';
import { OfficeDto } from '@/types/office.type';
import { ResponseStatus, SubscriptionStatus } from '@/common/constants';
import { ShiftDataDto } from '@/types/shift.type';
import { ShiftGroupResponseStatusFormDto } from '@/types/shift-response.type';

@Component({
  components: {
    EmployeeDetails,
    ShiftDeleteModal
  },
  computed: {
    ...mapState("Shift", 
    [
      "selectedOffice",
      "shiftData"
    ])
  }
})
export default class ShiftDetailModal extends Mixins(AuthMixin, ShiftMixin) {
  @Prop() shift?: RequestedShift;

  selectedOffice!: OfficeDto;
  shiftData!: ShiftDataDto;

  selectedEmployee: RequestedWorker | null = null;
  isEmployeeDetailsVisible = false;

  get employeeKey(): { userId: number, practiceId: number } {
    return { userId: this.selectedEmployee?.userId ?? 0, practiceId: this.userInfo()?.practiceId ?? 0  }
  }

  get isSubscriptionActive(): boolean {
    const subscriptionActiveStatus = SubscriptionStatus.Active.getId(this.shiftData.subscriptionStatuses);

    return this.selectedOffice?.subscriptionStatus === subscriptionActiveStatus;
  }

  formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = date.toLocaleString("default", { month: "long" });
    const weekDay = date.toLocaleString("default", { weekday: "long" });
    const day = date.getDate();

    return `${weekDay}, ${month} ${day}${this.nthNumber(day)}, ${year}`;
  }

  nthNumber(number: number): string {
    if (number > 3 && number < 21) {
      return "th";
    }

    switch (number % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  }

  showEmployeeDetailsModal(employee: RequestedWorker): void {
    this.selectedEmployee = employee;
    this.isEmployeeDetailsVisible = true;
  }
  
  async getShiftsInternal(value: { isFavorite: boolean, rating: number }): Promise<void> {
    const contextEmployee = this.shift?.requestedWorkers
        .find(worker => worker.userId === this.selectedEmployee?.userId);

    if (value && contextEmployee) {
      contextEmployee.isFavorite = value.isFavorite;
    }

    await this.$store.dispatch("Shift/getShifts", this.selectedOffice.id);
  }

  closeModal(): void {
    this.$bvModal.hide('shift-request-modal');
  }

  showDeleteModal(): void {
    this.$bvModal.show("shift-delete-modal");
  }

  onDelete(): void {
    this.$emit('delete');
    this.closeModal();
  }

  async accept(userId: number, shiftResponseId: number): Promise<void> {
    const subscriptionActiveStatus = SubscriptionStatus.Active.getId(this.shiftData.subscriptionStatuses);
    const subscriptionTrialingStatus = SubscriptionStatus.Trialing.getId(this.shiftData.subscriptionStatuses);

    if (this.selectedOffice?.subscriptionStatus !== subscriptionActiveStatus && this.selectedOffice?.subscriptionStatus !== subscriptionTrialingStatus) {
      this.$emit("notSubscribed");

      return;
    }

    this.setLoading(true);
    this.closeModal();

    await this.$store.dispatch("Shift/updateShiftResponseStatus", {
      id: shiftResponseId,
      userId,
      status: ResponseStatus.Confirmed.getId(this.shiftData.responseStatuses)
    } as ShiftGroupResponseStatusFormDto);

    await this.$store.dispatch("Shift/getOffices", { userId: this.userInfo()?.sub, officeId: this.selectedOffice.id });

    this.$emit("success");
    this.setLoading(false);
  }
}
